import React from 'react';

import { useDevice } from '@opendoor/bricks/hooks/useMedia';
import { Flex, Text } from '@opendoor/bricks/core';
import { colors } from '@opendoor/bricks/theme/eero';
import { useAuth } from '@opendoor/auth-fe';

interface IFinalUpdatePrompt {
  firstName?: string;
  expired: boolean;
}

// component-test-check-ignore
/**
 * Final Update Prompt Without Context
 *
 *  @param {string} firstName - first name of the user
 *  @param {boolean} expired - if the offer is expired
 */
export const FinalUpdatePromptWithoutContext: React.FC<IFinalUpdatePrompt> = ({
  firstName,
  expired,
}) => {
  const { isMobile } = useDevice();
  if (isMobile) {
    return null;
  }
  const beginningActiveOfferText = firstName ? `Hi ${firstName}, w` : 'W';
  const activeOfferText = `${beginningActiveOfferText}e’ve updated and finalized our offer`;

  const beginningExpiredOfferText = firstName ? `Hi ${firstName}, y` : 'Y';
  const expiredOfferText = `${beginningExpiredOfferText}our offer is expired`;

  return (
    <Flex
      p={7}
      borderRadius="roundedSquare"
      border={`1px solid ${colors.neutrals30}`}
      backgroundColor="neutrals0"
      data-testid="final-update-prompt"
    >
      <Text fontWeight="semibold" size="s1">
        {expired ? expiredOfferText : activeOfferText}
      </Text>
    </Flex>
  );
};

/**
 * Final Update Prompt
 */
export const FinalUpdatePrompt: React.FC<{ expired: boolean }> = ({ expired }) => {
  const { user } = useAuth();

  return <FinalUpdatePromptWithoutContext firstName={user?.firstName} expired={expired} />;
};
